// Registers the FabAxis service worker in production-like environments.
// Called once from index.js. Silent-fails on http (dev on localhost still
// works since SW is allowed on localhost & https origins).

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only register on secure contexts (https or localhost). The Kubernetes
  // preview URL is https, so this works in the field.
  const isSecure =
    window.location.protocol === "https:" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (!isSecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal — the app runs fine without SW, but PWA install prompt
        // won't appear. Log for diagnostics.
        // eslint-disable-next-line no-console
        console.warn("[FabAxis] Service worker registration failed:", err);
      });

    // Auto-reload the tab exactly once when a new service worker takes
    // over. This clears any stale JS bundle the user has been running
    // since the last deploy — without it the user would keep hitting
    // 404s from renamed/removed endpoints until they hard-refreshed.
    // The sessionStorage guard prevents an infinite reload loop in the
    // rare case skipWaiting fires before the page is interactive.
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      if (sessionStorage.getItem("fabaxis:sw-reloaded") === "1") return;
      reloading = true;
      sessionStorage.setItem("fabaxis:sw-reloaded", "1");
      window.location.reload();
    });
    // Clear the guard on next full session (new tab) so future updates
    // can still trigger the one-shot reload.
    window.addEventListener("beforeunload", () => {
      if (!reloading) sessionStorage.removeItem("fabaxis:sw-reloaded");
    });
  });
}
